import CheckoutWalletContainer from './CheckoutWalletContainer';

export default CheckoutWalletContainer;
